import React, {useState} from "react";
import {PageHeader} from "../../../../components/PageHeader";
import {AssetEosListType} from "./subPages/AssetEosListType";
import {toKSTISOString, toKSTISOStringEnd} from "../../../../components/commonmethod/CommonMethod";
import {addYears} from "date-fns";
import useRequestData from "../../../../hooks/useRequestData";
import {getEosAssets} from "../../../../api/asset/AssetService";

function AssetEosList() {
    const [checked,setChecked] = useState([]);

    const initDate ={
        startDate:toKSTISOString(addYears(new Date(),-1)),
        endDate:toKSTISOStringEnd(addYears(new Date(),0)),
    }

    const { newData, pageInfo, dataHook} = useRequestData(getEosAssets, initDate, "eos");

    return (
        <>
            <div className="common-container container-height-full">
                <PageHeader header={"자산EOS관리"} indicator={"자산관리 > 자산재무관리 > 자산EOS관리"} />
                <AssetEosListType checked={{checked: checked, setChecked: setChecked}}
                                  data={newData} date={initDate} pageInfo={pageInfo}
                                  dataHook={dataHook}
                />
            </div>
        </>
    );
}

export {AssetEosList}